import React from 'react';

import { ProductImage } from '@savgroup-front-common/core/atoms/ProductImage';
import { Field } from '@savgroup-front-common/core/molecules/Field';
import {
  ClaimContext,
  OrderDetailsProduct,
} from '@savgroup-front-common/types';

import messages from '../messages';
import {
  $CardContentThumbnail,
  $CardContentThumbnailWrapper,
  $ResumeDescriptionProduct,
  $ResumeInfoProduct,
  $ResumeInfoProductTitle,
  $ResumePictureProduct,
  $ResumeSeparator,
} from '../ResumeCard.styles';

import useResumeCardHeader from './ResumeCardHeader.hooks';

interface ResumeCardHeaderProps {
  product: OrderDetailsProduct;
  currentClaim?: ClaimContext;
  index: number;
}

const ResumeCardHeader: React.FC<ResumeCardHeaderProps> = ({
  product,
  currentClaim,
  index,
}) => {
  const { modelDetail, serialNumber } = useResumeCardHeader({
    product,
    currentClaim,
  });

  return (
    <>
      <$ResumeDescriptionProduct>
        <$ResumePictureProduct>
          <$CardContentThumbnailWrapper>
            <$CardContentThumbnail>
              <ProductImage pictureUrl={modelDetail?.pictureUrl} />
            </$CardContentThumbnail>
          </$CardContentThumbnailWrapper>
        </$ResumePictureProduct>

        <div>
          <$ResumeInfoProduct>
            <$ResumeInfoProductTitle
              data-testid={`ResumeCardHeader_modelDisplayName_${index}`}
              title={product?.modelDisplayName}
            >
              {product?.modelDisplayName}
            </$ResumeInfoProductTitle>

            {serialNumber && (
              <Field
                copy={serialNumber}
                label={messages.newSerialNumberLabel}
                dataTestId={`ResumeCardHeader_serialNumber_${index}`}
              >
                {serialNumber}
              </Field>
            )}
          </$ResumeInfoProduct>
        </div>
      </$ResumeDescriptionProduct>

      <$ResumeSeparator />
    </>
  );
};

export default ResumeCardHeader;
